import { render, staticRenderFns } from "./shencunzhuangtai.vue?vue&type=template&id=e9773368&"
import script from "./shencunzhuangtai.vue?vue&type=script&lang=js&"
export * from "./shencunzhuangtai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports